import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../api/auth.js';
import { get } from '../api/client.js';
import { Card, Field, Notice } from '../components/ui.js';

interface SetupState {
  completed: boolean;
  setup_available: boolean;
}

export function LoginPage(): JSX.Element {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const setupState = useQuery({
    queryKey: ['setup-state'],
    queryFn: () => get<SetupState>('/auth/setup-state'),
    retry: false,
  });

  useEffect(() => {
    document.title = 'تسجيل الدخول — منظومة الإذاعة المدرسية';
  }, []);

  const submit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'تعذر تسجيل الدخول');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="login-brand">
          <div className="mark" aria-hidden="true" />
          <h1>منظومة الإذاعة المدرسية</h1>
          <p>لوحة إدارة الجرس والإذاعة على مستوى المديرية</p>
        </div>

        {setupState.data?.setup_available ? (
          <Notice tone="info">
            لم يكتمل الإعداد الأولي بعد.{' '}
            <Link to="/setup">ابدأ إعداد أول مديرية ومسؤول</Link> باستخدام رمز الإعداد المطبوع من
            سكربت التثبيت.
          </Notice>
        ) : null}

        <Card>
          <form onSubmit={submit}>
            <Field label="البريد الإلكتروني">
              <input
                type="email"
                autoComplete="username"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Field>
            <Field label="كلمة المرور">
              <input
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Field>

            {error ? (
              <div className="notice danger" role="alert">
                {error}
              </div>
            ) : null}

            <button className="primary" type="submit" disabled={busy} style={{ width: '100%' }}>
              {busy ? 'جارٍ الدخول…' : 'تسجيل الدخول'}
            </button>
          </form>
        </Card>

        <p className="login-foot">
          لا توجد كلمة مرور افتراضية. تُنشأ الحسابات من لوحة المديرية أو عبر أداة الإدارة.
        </p>
      </div>
    </div>
  );
}
